<template>
  <div class="uk-modal" v-el:modal>
    <div class="uk-modal-dialog"
      :class="{
        'uk-modal-dialog-large': large
      }">
      <!-- close button -->
      <a href="" class="uk-modal-close uk-close"
        v-if="!block && !hideClose">
      </a>
      <!-- content -->
      <div v-el:content class="uk-modal-content"
        :class="{
          'uk-overflow-container': overflow
        }">
        <tm-spinner v-if="spinner"></tm-spinner>
        <div v-else class="uk-modal-content uk-flex uk-flex-middle">
          <i class="uk-icon-large uk-icon-justify uk-margin-right"
            v-if="icon.length"
            :class="icon">
          </i>
          <span v-html="text"></span>
        </div>
      </div>
      <!-- footer -->
      <div v-el:footer class="uk-modal-footer"
        v-if="requestError"
        :class="{
          'uk-text-right': !requestErrorVisible
        }">
        <tm-button v-if="!requestErrorVisible"
          @click="requestErrorVisible = true"
          text="Show details">
        </tm-button>
        <div v-else v-text="requestError"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'vuikit'

export default {
  extends: Modal,
  data: () => ({
    requestErrorVisible: false
  }),
  props: {
    requestError: {
      type: [String, Boolean],
      default: ''
    },
    icon: {
      type: [String, Array],
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    spinner: {
      type: Boolean,
      default: false
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** TmModal.vue?6a25b5a3
 **/